// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.regions-nav-floating {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: calc(100% - 96px);
}

.region-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 500;
  font-size: 13.5px;
  white-space: nowrap;
  border: 1px solid var(--border);
  background: var(--card-bg);
  color: var(--text-secondary);
  box-shadow: 0 4px 14px var(--shadow);
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
}

.region-pill:hover {
  background: var(--hover);
  color: var(--text-primary);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px var(--shadow-lg);
}

.region-pill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--region-color);
  flex-shrink: 0;
}

.region-pill.is-selected {
  background: color-mix(in srgb, var(--region-color) 16%, var(--card-bg));
  border-color: color-mix(in srgb, var(--region-color) 45%, transparent);
  color: var(--text-primary);
  font-weight: 600;
}

/* =========================================================
   FLOATING RESET BUTTON — bottom-right, independent of the
   pill cluster above. Already opaque on its own.
   ========================================================= */
.region-reset-btn-floating {
  position: absolute;
  bottom: 24px;
  right: 24px;
  z-index: 20;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: var(--card-bg);
  box-shadow: 0 4px 14px var(--shadow);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
}
.region-reset-btn-floating svg {
  font-size: 18px;
}
.region-reset-btn-floating:hover {
  background: var(--hover);
  color: var(--primary);
  border-color: var(--primary);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px var(--shadow-lg);
}

@media (max-width: 768px) {
  .regions-nav-floating {
    top: 14px;
    left: 14px;
    max-width: calc(100% - 78px);
    gap: 6px;
  }
  .region-pill {
    padding: 6px 11px;
    font-size: 13px;
  }
  .region-reset-btn-floating {
    bottom: 18px;
    right: 18px;
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .region-pill-dot {
    width: 7px;
    height: 7px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/map/RegionsNavigation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,eAAe;EACf,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;EACpC;+CAC6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,uEAAuE;EACvE,sEAAsE;EACtE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;8DAG8D;AAC9D;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf;+CAC6C;AAC/C;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,4BAA4B;IAC5B,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":[".regions-nav-floating {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 20;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-width: calc(100% - 96px);\n}\n\n.region-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 13.5px;\n  white-space: nowrap;\n  border: 1px solid var(--border);\n  background: var(--card-bg);\n  color: var(--text-secondary);\n  box-shadow: 0 4px 14px var(--shadow);\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n    box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.region-pill:hover {\n  background: var(--hover);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px var(--shadow-lg);\n}\n\n.region-pill-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--region-color);\n  flex-shrink: 0;\n}\n\n.region-pill.is-selected {\n  background: color-mix(in srgb, var(--region-color) 16%, var(--card-bg));\n  border-color: color-mix(in srgb, var(--region-color) 45%, transparent);\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* =========================================================\n   FLOATING RESET BUTTON — bottom-right, independent of the\n   pill cluster above. Already opaque on its own.\n   ========================================================= */\n.region-reset-btn-floating {\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  z-index: 20;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  border: 1px solid var(--border);\n  background: var(--card-bg);\n  box-shadow: 0 4px 14px var(--shadow);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n    box-shadow 0.15s ease, transform 0.15s ease;\n}\n.region-reset-btn-floating svg {\n  font-size: 18px;\n}\n.region-reset-btn-floating:hover {\n  background: var(--hover);\n  color: var(--primary);\n  border-color: var(--primary);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px var(--shadow-lg);\n}\n\n@media (max-width: 768px) {\n  .regions-nav-floating {\n    top: 14px;\n    left: 14px;\n    max-width: calc(100% - 78px);\n    gap: 6px;\n  }\n  .region-pill {\n    padding: 6px 11px;\n    font-size: 13px;\n  }\n  .region-reset-btn-floating {\n    bottom: 18px;\n    right: 18px;\n    width: 40px;\n    height: 40px;\n  }\n}\n\n@media (max-width: 480px) {\n  .region-pill-dot {\n    width: 7px;\n    height: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
